import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

const discount = new Restful(project, 'discount')
discount.edit = data => {
  const url = project + `discount`
  return http.put(url, data).then(res => {
    return res
  })
}

const discountJournalId = new Restful(project, 'discount/journalId')

discountJournalId.addDiscount = (id, discount, data) => {
  const url = project + `discount/journalId/${id}/discount/${discount}`
  return http.post(url, data).then(res => {
    return res
  })
}

const discountDetail = new Restful(project, 'discount/detail')

discountDetail.detailPerson = data => {
  const url = project + `discount/detail/person`
  return http.get(url, data).then(res => {
    return res
  })
}
discountDetail.code = (code, data) => {
  const url = project + `discount/detail/code/${code}`
  return http.get(url, data).then(res => {
    return res
  })
}

export { discount, discountJournalId, discountDetail }
